"use strict";
import {onFind} from "@elements/init-modules-in-scope";
import {on, hasClass, addClass, removeClass, find, findIn, closest, removeAttribute} from "@elements/dom-utils";
import {isScrollLock} from "@elements/scroll-lock";

let matchesMediaQuery = true;
const defaultOptions = {
    mediaQuery: null
};

export function init (options = defaultOptions) {
    matchesMediaQuery = options.mediaQuery ? matchMedia(options.mediaQuery).matches : true;

    options = {
        ...defaultOptions,
        ...options
    };

    if (options.mediaQuery) {
        matchMedia(options.mediaQuery).addListener(({matches}) => {
            matchesMediaQuery = matches;
        });
    }

    if(matchesMediaQuery){

        let form = find('.js-affix-form');
        let formContainer = find('.js-affix-form__container');
        const placeholder = find('.js-affix-form__placeholder');

        if (placeholder) {
            let formHeight = form.offsetHeight;
            let containerMargin = parseInt(getComputedStyle(formContainer).marginTop);
            let scrollPos = window.pageYOffset;
            let offset =  formHeight - form.offsetTop - containerMargin;
            let offsetLeft = form.offsetLeft;
            let width = form.offsetWidth;
            let offsetHeader = form.getAttribute('data-affix-form-offset');


            const addClassOnScroll = () => {
                addClass('is-affix', form);
                form.style["padding-left"] = offsetLeft + 'px';
                form.style["padding-right"] = document.body.clientWidth - offsetLeft - width + 'px';
                form.style["top"] = offsetHeader + 'px';
            }
            const removeClassOnScroll = () => {
                removeClass('is-affix', form);
                form.style["padding-left"] = 0;
                form.style["padding-right"] = 0;
            }

            if (!hasClass('js-affix-nav-placeholder--no-height', placeholder)) {
                placeholder.style.minHeight = form.getBoundingClientRect().height.toString() + "px";
            }

            if(window.pageYOffset >= formHeight - offset){
                addClassOnScroll();
            }

            window.addEventListener('scroll', function() {
                scrollPos = window.pageYOffset;

                if (scrollPos === 0 && !isScrollLock()) {
                    removeClassOnScroll();

                } else {
                    if (scrollPos >= formHeight - offset) {
                        addClassOnScroll();
                    } else {
                        if (!isScrollLock()) {
                            removeClassOnScroll();
                        }
                    }
                }
            }, false);
        }
    }
}
